import React from 'react';

import Page from 'components/Page';
import MultiGallery from 'components/MultiGallery';

const DoubleGalleryTemplate = ({ page: { acf: { gallery_1, gallery_2, gallery_1_name, gallery_2_name } } }) => {
    const galleries = [
        {
            name: gallery_1_name,
            images: gallery_1?.map((item) => item.image),
        },
        {
            name: gallery_2_name,
            images: gallery_2?.map((item) => item.image),
        }
    ];

    return (
        <Page>
            <MultiGallery galleries={galleries} />
        </Page>
    );
};

export default DoubleGalleryTemplate;